export default __webpack_public_path__ + "static/location_icon-2dca011d59a67d61fc244b54753bab47.png";